import { useEffect } from "react";
import { useThree } from "@react-three/fiber";
import * as THREE from "three";

/**
 * Permet d'attacher un écouteur de clics "raycastés" sur un objet arbitraire.
 * @param {THREE.Object3D | React.RefObject} target - Objet ou ref de l'objet à écouter
 * @param {(object: THREE.Object3D, event: MouseEvent) => void} onHit - Callback quand un objet est cliqué
 */
export default function useIntersectingClicks(target, onHit) {
  const { gl, camera } = useThree();

  useEffect(() => {
    const obj = target?.current || target;
    if (!obj) return;

    const mouse = new THREE.Vector2();
    const raycaster = new THREE.Raycaster();

    const handleClick = (event) => {
      const bounds = gl.domElement.getBoundingClientRect();
      mouse.x = ((event.clientX - bounds.left) / bounds.width) * 2 - 1;
      mouse.y = -((event.clientY - bounds.top) / bounds.height) * 2 + 1;

      raycaster.setFromCamera(mouse, camera);
      const hits = raycaster.intersectObject(obj, true); // true = traverse children

      if (hits.length > 0) {
        onHit(hits[0].object, event);
      }
    };

    gl.domElement.addEventListener("pointerdown", handleClick);
    return () => gl.domElement.removeEventListener("pointerdown", handleClick);
  }, [target, onHit, gl, camera]);
}
